module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Sex, Drugs and Rock ‘n’ Roll – Memoir of a Police Doctor")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#prologue-halloween1980-something"
    }
  }, [_vm._v("Prologue:  Halloween—1980 something")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-one-my-vocation"
    }
  }, [_vm._v("Chapter One:   My Vocation")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-two-medical-school"
    }
  }, [_vm._v("Chapter Two:   Medical School")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-three-hospital-doctor"
    }
  }, [_vm._v("Chapter Three:   Hospital Doctor")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-four-general-practice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four:   General Practice")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-five-the-police-come-calling",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five:   The Police Come Calling")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-six-some-facts-and-figures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six:   Some Facts and Figures")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-seven-practising-medicine-in-the-cells",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven:   Practising Medicine in the Cells")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-eight-dead-bodies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight:   Dead Bodies")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-nine-sex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine:   Sex")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-ten-driving-under-the-influence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten:   Driving Under the Influence")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-eleven-the-good-the-mad-and-the-ugly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven:   The Good, the Mad and the Ugly")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-twelve-drugs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve:   Drugs")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-thirteen-playing-away",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen:   Playing Away")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-fourteen-epilogue-aka-soapbox",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen:   Epilogue, AKA Soapbox")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0